module.exports = __webpack_public_path__ + "img/52.d93bac79.jpg";